import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  filter: drop-shadow(0 ${spacing(-0.5, 2.5)} ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.12)});
  transition: filter 0.2s ease-in-out;
  will-change: filter;
`
